import * as React from 'react';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './priceRelevanceWarningInfo.css';

interface IPriceRelevanceWarningInfo {
  onMouseEnter(): void;
  onMouseLeave(): void;
}

export const PriceRelevanceWarningInfo = React.forwardRef(
  ({ onMouseEnter, onMouseLeave }: IPriceRelevanceWarningInfo, ref: React.Ref<HTMLDivElement>) => {
    return (
      <div className={styles['container']} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} ref={ref}>
        <IconFunctionalInformationCircle16 color="icon-main-default" />
      </div>
    );
  },
);

PriceRelevanceWarningInfo.displayName = 'PriceRelevanceWarningInfo';
